/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignmentRequest } from '../models/AssignmentRequest';
import type { OpportunityCreate } from '../models/OpportunityCreate';
import type { OpportunityDetail } from '../models/OpportunityDetail';
import type { OpportunityHistory } from '../models/OpportunityHistory';
import type { OpportunityNote } from '../models/OpportunityNote';
import type { OpportunityStatusHistory } from '../models/OpportunityStatusHistory';
import type { OpportunityUpdate } from '../models/OpportunityUpdate';
import type { PaginatedOpportunityList } from '../models/PaginatedOpportunityList';
import type { PaginatedOpportunityNoteList } from '../models/PaginatedOpportunityNoteList';
import type { PatchedOpportunityNote } from '../models/PatchedOpportunityNote';
import type { PatchedOpportunityStatusUpdate } from '../models/PatchedOpportunityStatusUpdate';
import type { PatchedOpportunityUpdate } from '../models/PatchedOpportunityUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AssignmentsService {

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static assignmentsCalendarIcsCancellationRetrieve({
        assignmentId,
    }: {
        assignmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/calendar-ics-cancellation/{assignment_id}/',
            path: {
                'assignment_id': assignmentId,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static assignmentsCalendarIcsRetrieve({
        assignmentId,
    }: {
        assignmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/calendar-ics/{assignment_id}/',
            path: {
                'assignment_id': assignmentId,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityList
     * @throws ApiError
     */
    public static assignmentsOpportunitiesList({
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/',
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesCreate({
        requestBody,
    }: {
        requestBody: OpportunityCreate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody: OpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
        requestBody?: PatchedOpportunityNote,
    }): CancelablePromise<OpportunityNote> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNoteDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity Note.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities-note/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesRetrieve({
        id,
        provider,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Provider ID for rates
         */
        provider?: string,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            query: {
                'provider': provider,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: OpportunityUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityUpdate
     * @throws ApiError
     */
    public static assignmentsOpportunitiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityUpdate,
    }): CancelablePromise<OpportunityUpdate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static assignmentsOpportunitiesDestroy({
        id,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/assignments/opportunities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * !! Custom changes history that merges two kinds of history
     *
     * Handles the retrieval of change history for an Opportunity instance and its related
     * OpportunitySettings. The change history can be sorted in ascending or descending
     * order based on a query parameter.
     *
     * Args:
     * request: The HTTP request object.
     * *args: Additional positional arguments.
     * **kwargs: Additional keyword arguments.
     *
     * Returns:
     * Response: A Response object containing the aggregated and sorted change history
     * data for the Opportunity and its related OpportunitySettings.
     *
     * Raises:
     * Does not explicitly describe raised errors in this method.
     *
     * Note:
     * The `sort` query parameter is optional and determines the sort order of the
     * change history. Valid values are `asc` (ascending) and `desc` (descending).
     * @returns OpportunityHistory
     * @throws ApiError
     */
    public static assignmentsOpportunitiesChangeHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<OpportunityHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/change-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesList({
        id,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
        });
    }

    /**
     * @returns PaginatedOpportunityNoteList
     * @returns OpportunityNote
     * @throws ApiError
     */
    public static assignmentsOpportunitiesNotesCreate({
        id,
        requestBody,
        currentStatus,
        currentStatusCategory,
        facilityId,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        queue,
        search,
        sort,
        specialties,
        status,
        statusCategory,
        statusKind,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody: OpportunityNote,
        /**
         * Short code representation of the status for viewing and reports
         */
        currentStatus?: string,
        /**
         * Short code representation of the status category for viewing and reports
         */
        currentStatusCategory?: string,
        facilityId?: string,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ready_for_clearance` - Ready for Clearance
         * * `all` - All
         * * `active` - Active
         * * `for_review` - For Review
         * * `to_confirm` - To Confirm
         * * `in_credentialing` - In Credentialing
         * * `awaiting_provider` - Awaiting Provider
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `needs_response` - Needs Response
         * * `facility_review` - Facility Review
         * * `all` - All
         * * `active` - Active
         * * `closed` - Closed
         * * `all` - All
         * * `active` - Active
         * * `on_hold` - On Hold
         * * `closed` - Closed
         * * `all` - All
         */
        queue?: 'active' | 'all' | 'awaiting_provider' | 'closed' | 'facility_review' | 'for_review' | 'in_credentialing' | 'needs_response' | 'on_hold' | 'ready_for_clearance' | 'to_confirm',
        /**
         * A search term.
         */
        search?: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
        /**
         * Specialties
         *
         * * `ANESTHESIA` - Anesthesiology
         * * `CARDIOVASCULAR_DISEASE` - Cardiovascular Disease
         * * `COLON_AND_RECTAL_SURGERY` - Colon & Rectal Surgery
         * * `CRITICAL_CARE` - Critical Care Medicine
         * * `DERMATOLOGY` - Dermatology
         * * `EMERGENCY_MEDICINE` - Emergency Medicine
         * * `PRIMARY_CARE` - Family Medicine
         * * `GASTROENTEROLOGY` - Gastroenterology
         * * `GENERAL_PRACTICE` - General Practice
         * * `HOSPITAL_MEDICINE` - Hospitalist
         * * `INFECTIOUS_DISEASE` - Infectious Disease
         * * `INTERNAL_MEDICINE` - Internal Medicine
         * * `INTERVENTIONAL_CARDIOLOGY` - Interventional Cardiology
         * * `MEDICAL_ONCOLOGY` - Medical Oncology
         * * `NEPHROLOGY` - Nephrology
         * * `NEUROCRITICAL_CARE` - Neurocritical Care
         * * `NEUROLOGICAL_SURGERY` - Neurological Surgery
         * * `NEUROLOGY` - Neurology
         * * `OBSTETRICS_AND_GYNECOLOGY` - Obstetrics & Gynecology
         * * `OPHTHALMOLOGY` - Ophthalmology
         * * `ORAL_AND_MAXILLOFACIAL_SURGERY` - Oral & Maxillofacial Surgery
         * * `ORTHOPAEDIC_SURGERY` - Orthopaedic Surgery
         * * `OTOLARYNGOLOGY` - Otolaryngology
         * * `PAIN_MEDICINE` - Pain Medicine
         * * `PATHOLOGY` - Pathology
         * * `PEDIATRICS` - Pediatrics
         * * `PEDIATRIC_CRITICAL_CARE` - Pediatric Critical Care
         * * `PEDIATRIC_EMERGENCY_MEDICINE` - Pediatric Emergency Medicine
         * * `PEDIATRIC_INFECTIOUS_DISEASES` - Pediatric Infectious Diseases
         * * `PHYSICAL_MEDICINE_AND_REHABILITATION` - Physical Medicine & Rehabilitation
         * * `PLASTIC_SURGERY` - Plastic Surgery
         * * `PREVENTIVE_MEDICINE` - Preventive Medicine
         * * `PULMONOLOGY` - Pulmonary Disease
         * * `PSYCHIATRY` - Psychiatry
         * * `RADIOLOGY` - Radiology
         * * `SURGERY` - Surgery
         * * `THORACIC_SURGERY` - Thoracic Surgery (Cardiothoracic Vascular Surgery)
         * * `TRANSPLANT_SURGERY` - Transplant Surgery
         * * `UROLOGY` - Urology
         * * `INTERVENTIONAL_RADIOLOGY` - Vascular & Interventional Radiology
         * * `OTHER` - Other
         */
        specialties?: Array<'ANESTHESIA' | 'CARDIOVASCULAR_DISEASE' | 'COLON_AND_RECTAL_SURGERY' | 'CRITICAL_CARE' | 'DERMATOLOGY' | 'EMERGENCY_MEDICINE' | 'GASTROENTEROLOGY' | 'GENERAL_PRACTICE' | 'HOSPITAL_MEDICINE' | 'INFECTIOUS_DISEASE' | 'INTERNAL_MEDICINE' | 'INTERVENTIONAL_CARDIOLOGY' | 'INTERVENTIONAL_RADIOLOGY' | 'MEDICAL_ONCOLOGY' | 'NEPHROLOGY' | 'NEUROCRITICAL_CARE' | 'NEUROLOGICAL_SURGERY' | 'NEUROLOGY' | 'OBSTETRICS_AND_GYNECOLOGY' | 'OPHTHALMOLOGY' | 'ORAL_AND_MAXILLOFACIAL_SURGERY' | 'ORTHOPAEDIC_SURGERY' | 'OTHER' | 'OTOLARYNGOLOGY' | 'PAIN_MEDICINE' | 'PATHOLOGY' | 'PEDIATRICS' | 'PEDIATRIC_CRITICAL_CARE' | 'PEDIATRIC_EMERGENCY_MEDICINE' | 'PEDIATRIC_INFECTIOUS_DISEASES' | 'PHYSICAL_MEDICINE_AND_REHABILITATION' | 'PLASTIC_SURGERY' | 'PREVENTIVE_MEDICINE' | 'PRIMARY_CARE' | 'PSYCHIATRY' | 'PULMONOLOGY' | 'RADIOLOGY' | 'SURGERY' | 'THORACIC_SURGERY' | 'TRANSPLANT_SURGERY' | 'UROLOGY'>,
        /**
         * Status
         */
        status?: Array<string | null>,
        /**
         * Status Category
         */
        statusCategory?: string,
        /**
         * Status Kind
         *
         * * `D` - Draft
         * * `I` - Initial
         * * `T` - Transitory
         * * `F` - Final
         */
        statusKind?: Array<'D' | 'F' | 'I' | 'T'>,
    }): CancelablePromise<PaginatedOpportunityNoteList | OpportunityNote> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/opportunities/{id}/notes/',
            path: {
                'id': id,
            },
            query: {
                'current_status': currentStatus,
                'current_status__category': currentStatusCategory,
                'facility_id': facilityId,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'queue': queue,
                'search': search,
                'sort': sort,
                'specialties': specialties,
                'status': status,
                'status_category': statusCategory,
                'status_kind': statusKind,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OpportunityStatusHistory
     * @throws ApiError
     */
    public static assignmentsOpportunitiesStatusHistoryRetrieve({
        id,
        sort,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        /**
         * Sort direction. `asc` or `desc`
         */
        sort?: string,
    }): CancelablePromise<OpportunityStatusHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/assignments/opportunities/{id}/status-history/',
            path: {
                'id': id,
            },
            query: {
                'sort': sort,
            },
        });
    }

    /**
     * @returns OpportunityDetail
     * @throws ApiError
     */
    public static assignmentsOpportunitiesStatusUpdatePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this Opportunity.
         */
        id: string,
        requestBody?: PatchedOpportunityStatusUpdate,
    }): CancelablePromise<OpportunityDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/assignments/opportunities/{id}/status-update/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AssignmentRequest
     * @throws ApiError
     */
    public static assignmentsRequestsCreate({
        requestBody,
    }: {
        requestBody: AssignmentRequest,
    }): CancelablePromise<AssignmentRequest> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/assignments/requests/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
